import {
  Backdrop,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Button
} from '@mui/material'

const ClaimDealDialog = (props) => {
  const {
    open,
    closeModal,
    claimDealHandler
  } = props

  return (
    <Backdrop
      open={open}
      className="modal-filter"
    >
      <Dialog
        open={open}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          sx={{ textAlign: "center", textTransform: "uppercase" }}
        >
          Claim Deal
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography
              variant="div"
            >
              Are you sure want to claim this deal?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="btn-info btn-lg"
            onClick={claimDealHandler}
          >
            Claim
          </Button>
          <Button
            className="btn-default btn-lg"
            onClick={closeModal}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Backdrop>
  )
}

export default ClaimDealDialog;